export default `
  query getCategoryContentData($filters: CategoryFilterInput) {
    categoryList(filters: $filters) {
      uid
      name
      display_mode
      landing_page
      introduction
      introduction_page_builder_content
      description
      description_page_builder_content
      image
      cms_block {
        identifier
        content
        page_builder_content
      }
    }
  }
`;
